export const PROSPECT_VIEWER_HOME_PATH = '/view/prospects';
export const PROSPECT_VIEWER_CLAIM_PATH = '/auth/prospect-claim';

export const PROSPECT_VIEWER_ALLOWED_PATHS: readonly string[] = [
  PROSPECT_VIEWER_CLAIM_PATH,
  PROSPECT_VIEWER_HOME_PATH,
];

function normalizePath(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export function isProspectViewerAllowedPath(pathname: string): boolean {
  const p = normalizePath(pathname);
  return PROSPECT_VIEWER_ALLOWED_PATHS.includes(p);
}

export function resolveProspectViewerPublicRedirect(
  role: string | null | undefined,
  _redirectParam: string | null | undefined
): string | null {
  if (role === 'prospect_viewer') {
    return PROSPECT_VIEWER_HOME_PATH;
  }
  return null;
}

export function resolveProspectViewerProtectedRedirect(
  role: string | null | undefined,
  pathname: string
): string | null {
  if (role !== 'prospect_viewer') return null;
  if (isProspectViewerAllowedPath(pathname)) return null;
  return PROSPECT_VIEWER_HOME_PATH;
}

export function resolveProspectViewerClaimSuccessPath(
  _redirectParam?: string | null
): string {
  return PROSPECT_VIEWER_HOME_PATH;
}
